import BrandedLogo from "@/components/BrandedLogo";

export type NotFoundProps = {
  header?: string;
  message?: string;
  orgID?: string;
};

const NotFound = ({ header, message, orgID }: NotFoundProps) => {
  return (
    <>
      <div className="flex min-h-full flex-col bg-white pt-16 pb-12">
        <main
          className="
            mx-auto flex w-full max-w-7xl grow flex-col justify-center px-4
            sm:px-6
            lg:px-8
          "
        >
          <div className="flex shrink-0 justify-center">
            <span className="sr-only">Not found.</span>
            <div className="inline-flex w-48 shrink-0 items-center justify-center rounded-lg">
              <BrandedLogo orgID={orgID} />
            </div>
          </div>
          <div className="py-16">
            <div className="text-center">
              <p className="text-sm font-semibold tracking-wide text-primary-600 uppercase">404 error</p>
              <h1
                className="
                  mt-2 text-4xl font-extrabold tracking-tight text-gray-900
                  sm:text-5xl
                "
              >
                {header ?? "Not found."}
              </h1>
              <p className="mt-2 text-base text-gray-500">{message ?? "The requested page was not found."}</p>
            </div>
          </div>
        </main>
      </div>
    </>
  );
};

export default NotFound;
